$(function () {

    $(document).ready(function () {

        var carousels = $('.feature-slider');

        if (carousels.length > 0) {
            carousels.each(function (i, e) {
                $(this).owlCarousel({
                    loop: true,
                    nav: true,
                    dots: false,
                    navText: ["<i class='fa fa-chevron-left fa-lg'><span class='sr-only'>Previous</span></i>", "<i class='fa fa-chevron-right fa-lg'><span class='sr-only'>Next</span></i>"],
                    responsive: {
                        0: {
                            items: $(this).data('mobile-display-amt')
                        },
                        992: {
                            items: $(this).data('desktop-display-amt')
                        }
                    },
                    onInitialized: function (event) {
                        $(this).find('.owl-item').attr('aria-selected', 'false');
                        // let screen readers know an item is active
                        $(this).find('.owl-item.active').attr('aria-selected', 'true');

                        // apply meta info to next and previous buttons and make them focusable
                        $(this).find('.owl-prev').attr('role', 'button').attr('title', 'Previous');
                        $(this).find('.owl-next').attr('role', 'button').attr('title', 'Next');
                        $(this).find('.owl-prev, .owl-next').attr('tabindex', '0');

                        // listen for keyboard input
                        $(document).on('keydown', function (e) {

                            var $focusedElement = $(document.activeElement),
                                singleOwl = $(this).data('owlCarousel'),
                                type = e.which == 39 ? 'next' : null,
                                type = e.which == 37 ? 'prev' : type,
                                type = e.which == 13 ? 'enter' : type;

                            // if the carousel is focused, use left and right arrow keys to navigate
                            if ($focusedElement.data('carousel-id') === this.data('carousel-id')) {

                                if (type == 'next') {
                                    singleOwl.next();
                                } else if (type == 'prev') {
                                    singleOwl.prev();
                                }

                                // if the prev and next buttons are focused, catch "Enter" and navigate in the right direction
                            } else if (type == 'enter') {
                                if ($focusedElement.hasClass('owl-next')) {
                                    singleOwl.next();
                                } else if ($focusedElement.hasClass('owl-prev')) {
                                    singleOwl.prev();
                                }
                            }
                        });
                    }
                });
            });
        }
    });
});